import { Image } from "react-konva";
import React from "react";

export const CanvasPirateShip = ({shipImage, rotation}) => {
  const width = 120;
  const height = 60;

  return(
    <Image
      image={shipImage}
      width={width}
      height={height}
      offsetX={width/2}
      offsetY={height/2}
      rotation={rotation}
      preventDefault={false}
    />
  )
};
